import { getDownloadURL, ref, getStorage } from "firebase/storage";

export async function getDownloadURLFromCloud(fileName: string) {
  const store = getStorage();
  return await getDownloadURL(ref(store, "files/" + fileName));
}
